export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系投稿</h2>
          <p className="text-sm text-foreground-600 mb-8">
            有优质漫画推荐或汉化作品想要投稿？欢迎通过以下方式与我们取得联系
          </p>
          <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/80">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-send-line text-2xl text-primary-600"></i>
              </div>
              <div className="text-left flex-1">
                <h3 className="font-heading text-lg text-foreground-900 mb-2">漫画推荐 & 汉化投稿</h3>
                <p className="text-sm text-foreground-600 mb-3">
                  请将漫画名称、来源链接和简要介绍发送至我们的内容团队，审核通过后将在3个工作日内安排上架。
                  也欢迎汉化组与我们建立长期合作关系，共同为读者带来更多优质内容。
                </p>
                <div className="inline-flex items-center gap-2 bg-background-100 text-foreground-700 px-4 py-2 rounded-md text-sm font-medium border border-background-300">
                  <i className="ri-mail-line text-primary-500"></i>
                  <span>contact@maoqucomic.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}